export const HOMEPAGE = 'HOMEPAGE';
export const CAMPAIGN = 'CAMPAIGN';
export const ZERORESULT = 'ZERORESULT';

export const FCIS_CALLER_ID = 'marketplace';
export const FCIS_CALLER_ID_CONFIGURATION = 'mm';

export const MODEL_D_MARKETS = ['AT'];
